import { render } from "./AdminsLog.vue?vue&type=template&id=0a82a32c"
import script from "./AdminsLog.vue?vue&type=script&lang=js"
export * from "./AdminsLog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__